<div class="progress-loader" [hidden]="!(loading$ | async)">
  <div class="loading-spinner">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div class="loader-message" *ngIf="message$ | async as message">
      {{ message }}
    </div>
  </div>
</div>
